<template>
	<div class="admin-layout">
		<header-block :title="pageTitle" :bgcolor="headerBgColor" :color="headerTextColor" border="0"></header-block>

		<div class="admin-content">
			<AdminSideNav :activeItem="activeMenuItem" @item-selected="handleMenuItemSelect" />

			<div class="main-content">
				<router-view />
			</div>
		</div>
	</div>
</template>

<script>
import HeaderBlock from '@/components/elements/HeaderBlock.vue';
import AdminSideNav from '@/admin/components/AdminSideNav.vue';

export default {
	name: 'AdminLayout',
	components: {
		HeaderBlock,
		AdminSideNav
	},
	data() {
		return {
			activeMenuItem: 'dashboard',
			isDarkMode: false
		}
	},
	computed: {
		pageTitle() {
			return this.$route.meta?.title || 'Money Guided Admin Home';
		},
		headerBgColor() {
			return this.isDarkMode ? '#16213e' : '#FBF7F4dd';
		},
		headerTextColor() {
			return this.isDarkMode ? '#e0e0e0' : 'black';
		}
	},
	methods: {
		handleMenuItemSelect(itemId) {
			this.activeMenuItem = itemId;
		},
		applyTheme() {
			const root = document.documentElement;
			if (this.isDarkMode) {
				root.classList.add('dark-mode');
				root.classList.remove('light-mode');
			} else {
				root.classList.add('light-mode');
				root.classList.remove('dark-mode');
			}
			// Update root so App.vue can reactively track dark mode
			this.$root.isDarkMode = this.isDarkMode;
		},
		toggleDarkMode() {
			this.isDarkMode = !this.isDarkMode;
			localStorage.setItem('adminDarkMode', JSON.stringify(this.isDarkMode));
			this.applyTheme();
		}
	},
	mounted() {
		// Load theme preference from localStorage
		const savedTheme = localStorage.getItem('adminDarkMode');
		if (savedTheme !== null) {
			this.isDarkMode = JSON.parse(savedTheme);
		}
		// Apply theme to document
		this.applyTheme();
	}
}
</script>

<style scoped>
@import './styles/admin-common.css';

.admin-layout {
	min-height: 100vh;
}

.admin-content {
	display: flex;
	gap: 20px;
	padding: 20px 0;
	margin-top: 10px;
	align-items: flex-start;
}

.main-content {
	flex: 1;
	background-color: var(--admin-bg-secondary);
	border-radius: var(--border-radius-m);
	padding: 25px;
	box-shadow: var(--box-shadow);
	min-height: calc(100vh - 200px);
	color: var(--admin-text-primary);
	transition: background-color 0.3s ease, color 0.3s ease;
}

@media (max-width: 768px) {
	.admin-content {
		flex-direction: column;
		gap: 15px;
	}

	.main-content {
		padding: 20px;
		min-height: auto;
	}
}

@media (max-width: 480px) {
	.admin-content {
		margin: 0 -30px;
		width: calc(100% + 60px);
		padding: 0 10px;
		box-sizing: border-box;
	}

	.main-content {
		padding: 15px;
		border-radius: var(--border-radius-s);
		width: 100%;
		box-sizing: border-box;
	}
}
</style>
